/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";

import bindHomeEffects from "./home";
import bindQuoteEffects from "./quote";
import bindRouteEffects from "./route";
import bindOrderEffects from "./order";
import bindBrandEffects from "./brand";
import bindPopularEffects from "./popular";
import bindCmsPageEffects from "./cms-page";
import bindCmsBlockEffects from "./cms-block";
import bindSearchEffects from "./search";
import bindAllProductsEffects from "./all-products";
import bindAdventCalendarEffects from "./advent-calendar";

type History = {
  push: (path: string) => void,
};

export const registerClient = (storage: Storage, client: Client<{}>, history: History) => {
  bindRouteEffects(storage, client);
  bindHomeEffects(storage, client);
  bindQuoteEffects(storage, client);
  bindOrderEffects(storage, client);
  bindBrandEffects(storage, client);
  bindPopularEffects(storage, client);
  bindCmsPageEffects(storage, client);
  bindCmsBlockEffects(storage, client);
  bindSearchEffects(storage, client, history);
  bindAllProductsEffects(storage, client);
  bindAdventCalendarEffects(storage, client);
};
